import co from 'co';

import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';
import { console, dom } from 'react-redux-app/lib/modules/core/utils';
import { changeLangForRequestUri } from '../../../core/i18n/utils';
import { getLoginUrl } from '../../../auth/utils';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import { actionLoginRequest } from '../../../auth/actions';

import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';
import { getAuthError, getLoginError } from '../../../auth/selectors';


const loginHandler = (
  { getState, dispatch },
  nextState,
  successCallback,
  errorCallback,
  commandParams,
  currentUri
) => {
  function* processLoginCommand() {
    yield dispatch(actionLoginRequest(commandParams.nick, commandParams.token));
    if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
      return;
    }

    const loginError = getLoginError(getState());
    if (
      loginError
      && !maybeHandleCriticalError(nextState.location, loginError.globalErrors, errorCallback)
    ) {
      dom.redirect(getLoginUrl(getState(), commandParams.lang));
      return;
    }

    const authError = getAuthError(getState());
    if (
      authError
      && !maybeHandleCriticalError(nextState.location, authError.globalErrors, errorCallback)
    ) {
      errorCallback(INTERNAL_ERROR_URI);
      return;
    }

    const currentLang = getCurrentLang(getState());
    if (commandParams.lang && commandParams.lang !== currentLang) {
      const newUri = changeLangForRequestUri(currentUri, commandParams.lang);
      errorCallback(newUri);
      return;
    }

    successCallback();
  }

  co(
    processLoginCommand()
  ).catch(error => {
    console.consoleError('loginHandler failed', error);
    successCallback();
  });
};

export const handler = loginHandler;
export const params = ['nick', 'token', 'lang'];
